import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client, throwFriendlyApiError } from '../common';

type Variables = {
  id: number;
  email: string;
};

export const useResendAdditionalDriver = createMutation<
  unknown,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/reservations/${variables.id}/additional-drivers/resend`,
      method: 'POST',
      data: {
        email: variables.email,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => throwFriendlyApiError(err, 'resend invite')),
});
